jQuery($ => {
  class MeganavTrigger {
    constructor(element, args = {}) {
      this._ = element;
      this._element = $(element);
      this._triggerId = this._element.attr('id');
      this.navId = this._element.attr('aria-controls');

      this._meganav = $(`#${this.navId}`);
      this._focusable = this._meganav.find(
        'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      this._meganavCaret = this._meganav.find('.a-caret');
      this._hoverCloseTimeout = null;

      this.settings = $.extend({
        offset: 20,
        margin: 40
      }, args);

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._element.on('mouseenter', this.handleTriggerMouseenter);
      this._element.on('mouseleave', this.handleTriggerMouseleave);
      this._element.on('mousedown', this.handleTriggerMousedown);
      this._element.on('keydown', this.handleTriggerKeydown);
      this._meganav.on('mouseenter', this.handleMeganavMouseenter);
      this._meganav.on('mouseleave', this.handleMeganavMouseleave);
      this._meganav.on('keydown', this.handleMeganavKeydown);
      $(document).on('click', this.handleOutsideClick);

      $(window).on('resize', this.handleRecalculatePositions);
      this._meganav.on('change', this.handleRecalculatePositions);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Recalculate Positions
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleRecalculatePositions = () => {
      this.setMeganavPosition();
      this.setCaretPosition();
    }

    canUseHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    clearHoverCloseTimeout = () => {
      if (!this._hoverCloseTimeout) return;

      clearTimeout(this._hoverCloseTimeout);
      this._hoverCloseTimeout = null;
    }

    queueHoverClose = () => {
      this.clearHoverCloseTimeout();

      this._hoverCloseTimeout = setTimeout(() => {
        const activeElement = document.activeElement;

        if (
          activeElement &&
          (this._.contains(activeElement) || (this._meganav[0] && this._meganav[0].contains(activeElement)))
        ) {
          return;
        }

        this.handleMeganavClose({ focusTrigger: false });
      }, 120);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Set Meganav To Open
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setMeganavOpen = () => {
      this._meganav
        .addClass('m-meganav-trigger__meganav--open')
        .attr('tabindex', '1');

      this.setMeganavPosition();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Set Meganav To Closed
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setMeganavClosed = () => {
      this._meganav
        .removeClass('m-meganav-trigger__meganav--open')
        .removeAttr('tabindex');

      this._meganav.trigger('reset');
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Set Meganav Position
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    // Set the position of the meganav relative to the trigger
    setMeganavPosition = () => {
      const triggerRect = this._element[0].getBoundingClientRect();
      const triggerLeft = triggerRect.left;
      const triggerRight = triggerRect.right;
      const triggerBottom = triggerRect.bottom;
      const triggerWidth = triggerRect.width;
      const navWidth = this._meganav[0].offsetWidth;
      const screenWidth = window.innerWidth;



      // Get any custom margin from CSS and adjust if necessary
      const computedStyle = getComputedStyle(this._meganav[0]);
      const varMargin = computedStyle.getPropertyValue('--meganav-margin');
      const margin = Math.max(0, this.settings.margin - parseInt(varMargin));
      const verticalOffset = this.settings.offset;
      let topScroll = $(window).scrollTop();

      // Default position is center below the trigger
      let leftPos = triggerLeft + (triggerWidth / 2) - (navWidth / 2);
      let topPos = triggerBottom + verticalOffset + topScroll;
      let useRight = false;

      // Decide whether to use 'right' positioning instead of 'left'
      if (triggerLeft + (triggerWidth / 2) > screenWidth / 2) {
        useRight = true;
      }

      // Adjust position if nav is beyond margin boundary
      if (useRight) {
        // Calculate right position to center the nav with the trigger
        let rightPos = screenWidth - triggerRight - (navWidth / 2) + (triggerWidth / 2);
        // Ensure the nav doesn't exceed the screen margin
        if (rightPos < margin) {
          rightPos = margin;
        }
        this._meganav.css({
          right: `${rightPos}px`,
          top: `${topPos}px`
        }).css('left', 'auto');
      } else {
        // Adjust left position if it exceeds the screen boundaries
        if (leftPos < margin) {
          leftPos = margin;
        } else if (leftPos + navWidth > screenWidth - margin) {
          leftPos = screenWidth - margin - navWidth;
        }
        this._meganav.css({
          left: `${leftPos}px`,
          top: `${topPos}px`
        }).css('right', 'auto');
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Set Caret Position
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setCaretPosition = () => {
      const triggerRect = this._element[0].getBoundingClientRect();
      const meganavRect = this._meganav[0].getBoundingClientRect();

      const triggerCenter = triggerRect.left + (triggerRect.width / 2);
      const meganavLeft = meganavRect.left;
      const leftPos = triggerCenter - meganavLeft - 28;

      // Apply calculated position to the caret
      this._meganavCaret.css({
        left: `${leftPos}px`,
      });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Set Trigger To Active
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setTriggerActive = () => {
      this._element
        .attr('aria-expanded', 'true')
        .addClass('m-meganav-trigger--active');
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Set Trigger To Inactive
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setTriggerInactive = () => {
      this._element
        .attr('aria-expanded', 'false')
        .removeClass('m-meganav-trigger--active');
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Meganav Opening
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleMeganavOpen = ({ focusMenu = true } = {}) => {
      this.clearHoverCloseTimeout();

      if (this._element.hasClass('m-meganav-trigger--active')) return;

      $('.m-meganav-trigger--active').each((_, trigger) => {
        $(trigger).meganav_trigger('setMeganavClosed');
        $(trigger).meganav_trigger('setTriggerInactive');
      });

      this.setTriggerActive();
      this.setMeganavOpen();
      this.setCaretPosition();

      if (focusMenu) {
        setTimeout(() => {
          this._meganav.focus();
        }, 100);
      }

      this._element.trigger('open', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Closing
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleMeganavClose = ({ focusTrigger = true } = {}) => {
      this.clearHoverCloseTimeout();
      this.setMeganavClosed();
      this.setTriggerInactive();

      if (focusTrigger) {
        this._element.focus();
      }

      this._element.trigger('close', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Meganav Toggle
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleMeganavToggle = () => {
      if (this._element.hasClass('m-meganav-trigger--active')) {
        this.handleMeganavClose();
      } else {
        this.handleMeganavOpen();
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Trigger Mousedown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTriggerMouseenter = () => {
      if (!this.canUseHover()) return;

      this.handleMeganavOpen({ focusMenu: false });
    }

    handleTriggerMouseleave = () => {
      if (!this.canUseHover()) return;

      this.queueHoverClose();
    }

    handleMeganavMouseenter = () => {
      if (!this.canUseHover()) return;

      this.clearHoverCloseTimeout();
    }

    handleMeganavMouseleave = () => {
      if (!this.canUseHover()) return;

      this.queueHoverClose();
    }

    handleTriggerMousedown = () => {
      if (this.canUseHover()) return;

      this.handleMeganavToggle();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Trigger Keydown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTriggerKeydown = event => {
      switch (event.key) {
        case 'Enter':
        case 'spacebar':
        case ' ':
          event.preventDefault();

          this.handleMeganavOpen();
          break;
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Meganav Keydown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleMeganavKeydown = event => {
      const $firstFocusable = this._focusable[0];
      const $lastFocusable = this._focusable[this._focusable.length - 1];

      switch (event.key) {
        case 'Tab':
          if (
            ($(event.target).is($lastFocusable) && !event.shiftKey) ||
            ($(event.target).is($firstFocusable) && event.shiftKey)
          ) {
            event.preventDefault();

            if ($(event.target).is($lastFocusable)) {
              $firstFocusable.focus();
            } else {
              $lastFocusable.focus();
            }
          } else if ($(event.target).is(".m-meganav-trigger__meganav")) {
            event.preventDefault();

            $firstFocusable.focus();
          }
          break;

        case 'ArrowRight':
        case 'ArrowDown':
          if ($(event.target).is(".m-meganav-trigger__meganav")) {
            event.preventDefault();

            $firstFocusable.focus();
          }
          break;

        case 'Escape':
        case 'Esc':
          this.handleMeganavClose();
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Clicking Outside Drawer
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleOutsideClick = event => {
      if (this._meganav.hasClass('m-meganav-trigger__meganav--open') && !this._.contains(event.target)) {
        if (this._meganav[0] && this._meganav[0].contains(event.target)) return;

        this.handleMeganavClose({ focusTrigger: false });
        this._element.trigger('clickoutClose', this);
      }
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.meganav_trigger = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].meganav_trigger = new MeganavTrigger(_[i], opt);
      else
        ret = _[i].meganav_trigger[opt].apply(_[i].meganav_trigger, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.m-meganav-trigger').meganav_trigger();
});